import { render } from "./ListMenuItems.vue?vue&type=template&id=bb682140"
import script from "./ListMenuItems.vue?vue&type=script&lang=js"
export * from "./ListMenuItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__